import { resolveApiBaseUrl } from '../utils/apiBase';
import { ensureCsrfCookie, xsrfHeaders } from './authApi';

const API = () => resolveApiBaseUrl();

async function jsonFetch(path, options = {}) {
  await ensureCsrfCookie();
  const response = await fetch(`${API()}${path}`, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...xsrfHeaders(),
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...options.headers,
    },
    ...options,
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || err.error || `Request failed (${response.status})`);
  }
  if (response.status === 204) return null;
  return response.json();
}

export async function getAdminDeskSeed(columnId) {
  return jsonFetch(`/v1/admin/desk-seeds/${columnId}`);
}

export async function updateAdminDeskSeed(columnId, terms) {
  return jsonFetch(`/v1/admin/desk-seeds/${columnId}`, {
    method: 'PUT',
    body: JSON.stringify({ terms }),
  });
}
